export const HomepageStartEditingImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="120"
      height="57"
      viewBox="0 0 120 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12887_129910)">
        <g filter="url(#filter0_d_12887_129910)">
          <circle cx="23.5" cy="33" r="20" fill="white" />
        </g>
        <path
          d="M31.9444 24H14.0556C12.8889 24 12.5 25.0405 12.5 26.6013V39.0874C12.5 40.6482 12.8889 41.1685 14.0556 41.6887C15.2222 42.209 31.2904 41.9199 32.0682 41.9199C32.846 41.9199 33.5 41.1685 33.5 40.1279V25.5608C33.5 24.5203 32.8784 24.0722 31.9444 24Z"
          fill="#2164DA"
        />
        <rect x="16.5" y="38" width="14" height="1" fill="#B99BF9" />
        <path
          d="M26.9 38.5008C26.9 39.1635 26.3627 39.7008 25.7 39.7008C25.0373 39.7008 24.5 39.1635 24.5 38.5008C24.5 37.838 25.0373 37.3008 25.7 37.3008C26.3627 37.3008 26.9 37.838 26.9 38.5008Z"
          fill="white"
        />
        <path
          d="M20.5079 34.2252C20.5079 33.6773 20.4901 28.2357 20.508 27.6507C20.5259 27.0658 20.5092 26.8535 21.1088 27.1029C21.7085 27.3522 25.719 29.5169 26.517 29.9233C27.3151 30.3296 27.9291 30.9021 27.1179 31.6155C26.3068 32.3289 22.7267 34.2252 21.9871 34.7731C21.2475 35.3209 20.5079 34.7731 20.5079 34.2252Z"
          fill="white"
        />
        <g filter="url(#filter1_d_12887_129910)">
          <circle cx="58.5" cy="24" r="20" fill="white" />
        </g>
        <path
          d="M66.9444 15H49.0556C47.8889 15 47.5 16.0405 47.5 17.6013V30.0874C47.5 31.6482 47.8889 32.1685 49.0556 32.6887C50.2222 33.209 66.2904 32.9199 67.0682 32.9199C67.846 32.9199 68.5 32.1685 68.5 31.1279V16.5608C68.5 15.5203 67.8784 15.0722 66.9444 15Z"
          fill="#2164DA"
        />
        <path
          d="M61.5 22C61.5 22.5523 61.0523 23 60.5 23C59.9477 23 59.5 22.5523 59.5 22C59.5 21.4477 59.9477 21 60.5 21C61.0523 21 61.5 21.4477 61.5 22Z"
          fill="#B99BF9"
        />
        <path
          d="M65.5 28.0154H51C50.4999 28.0154 50.0686 27.6448 50.5 27.0154C50.9315 26.3859 54.0001 21.0307 54.5 20.0154C55 19.0001 56 19.0001 56.5 20.0154C56.921 20.8702 59.1608 26.2199 59.3304 26.61C59.5 27 59.5 27 59.7719 26.7311C60.0438 26.4622 62.0828 24.3336 62.5 24.0154C63.0243 23.6156 63.0289 23.6536 63.5 24.0154C63.9712 24.3771 66 26.5 66.5 27.0154C67.0001 27.5308 66.5 28.0153 65.5 28.0154Z"
          fill="white"
        />
        <g filter="url(#filter2_d_12887_129910)">
          <circle cx="93.5" cy="33" r="20" fill="white" />
        </g>
        <path
          d="M101.944 24H84.0556C82.8889 24 82.5 25.0405 82.5 26.6013V39.0874C82.5 40.6482 82.8889 41.1685 84.0556 41.6887C85.2222 42.209 101.29 41.9199 102.068 41.9199C102.846 41.9199 103.5 41.1685 103.5 40.1279V25.5608C103.5 24.5203 102.878 24.0722 101.944 24Z"
          fill="#2164DA"
        />
        <rect x="85.5" y="26" width="7" height="14" rx="0.5" fill="white" />
        <rect x="93.5" y="26" width="7" height="6" rx="0.5" fill="white" />
        <rect x="93.5" y="33" width="7" height="7" rx="0.5" fill="#B99BF9" />
      </g>
      <defs>
        <filter
          id="filter0_d_12887_129910"
          x="-2.5"
          y="7"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12887_129910"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12887_129910"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_12887_129910"
          x="32.5"
          y="-2"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12887_129910"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12887_129910"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_12887_129910"
          x="67.5"
          y="7"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12887_129910"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12887_129910"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_12887_129910">
          <rect
            width="119"
            height="57"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
